/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Produced by `npm run api:generate` from `openapi/oui-observe-api.yaml`.
 * Edit the specification, then regenerate. A hand edit here is lost on the next run, and the
 * `api:check` CI gate will notice before you do.
 */

/* eslint-disable */

import type { ApiOperation } from './runtime'
import type {
  AlertRuleAlertRuleInput,
  AlertRuleAlertRuleInputJsonMergePatch,
  AlertRuleJsonld,
  AssetAssetInput,
  AssetAssetPatchJsonMergePatch,
  AssetJsonld,
  CapabilityJsonld,
  EnrollmentTokenEnrollmentTokenInput,
  EnrollmentTokenJsonld,
  EventJsonld,
  EventStatisticJsonld,
  ExtensionJsonld,
  GroupGroupInput,
  GroupGroupInputJsonMergePatch,
  GroupJsonld,
  HydraCollectionBaseSchema,
  HydraCollectionBaseSchemaNoPagination,
  ManifestJsonld,
  MetricSeriesJsonld,
  MfaChallengeJsonld,
  MfaChallengeMfaVerification,
  NotificationChannelJsonld,
  NotificationChannelNotificationChannelInput,
  NotificationChannelNotificationChannelInputJsonMergePatch,
  OperationJsonld,
  OperationOperationRequest,
  ReauthenticationJsonld,
  ReauthenticationReauthenticationRequest,
  RoleJsonld,
  SessionJsonld,
  SessionRefreshRequest,
  UptimeSummaryJsonld,
  UserJsonld,
  UserUserInput,
  UserUserInputJsonMergePatch,
} from './schema'

export interface ApiV1alertRulesGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** AlertRule enabled */
  enabled?: boolean
  /** all | group | asset | kind | tag. */
  scope_type?: string
  /** debug | info | warning | error | critical. */
  severity?: string
  /** AlertRule q */
  q?: string
}
export type ApiV1alertRulesGetCollectionResponse = HydraCollectionBaseSchema & {
  member: AlertRuleJsonld[]
}

/**
 * Retrieves the collection of AlertRule resources.
 *
 * Retrieves the collection of AlertRule resources.
 */
export const api_v1alert_rules_get_collection: ApiOperation<
  undefined,
  ApiV1alertRulesGetCollectionQuery,
  undefined,
  ApiV1alertRulesGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1alert-rules_get_collection",
  method: "GET",
  path: "/api/v1/alert-rules",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "enabled", "scope_type", "severity", "q"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1alertRulesIdDeletePath {
  /** AlertRule identifier */
  id: string
}
export type ApiV1alertRulesIdDeleteResponse = void

/**
 * Removes the AlertRule resource.
 *
 * Removes the AlertRule resource.
 */
export const api_v1alert_rules_id_delete: ApiOperation<
  ApiV1alertRulesIdDeletePath,
  undefined,
  undefined,
  ApiV1alertRulesIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1alert-rules_id_delete",
  method: "DELETE",
  path: "/api/v1/alert-rules/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 204,
  emptyResponse: true,
}

export interface ApiV1alertRulesIdGetPath {
  /** AlertRule identifier */
  id: string
}
export type ApiV1alertRulesIdGetResponse = AlertRuleJsonld

/**
 * Retrieves a AlertRule resource.
 *
 * Retrieves a AlertRule resource.
 */
export const api_v1alert_rules_id_get: ApiOperation<
  ApiV1alertRulesIdGetPath,
  undefined,
  undefined,
  ApiV1alertRulesIdGetResponse,
  undefined
> = {
  operationId: "api_v1alert-rules_id_get",
  method: "GET",
  path: "/api/v1/alert-rules/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1alertRulesIdPatchBody = AlertRuleAlertRuleInputJsonMergePatch
export interface ApiV1alertRulesIdPatchPath {
  /** AlertRule identifier */
  id: string
}
export type ApiV1alertRulesIdPatchResponse = AlertRuleJsonld

/**
 * Updates the AlertRule resource.
 *
 * Updates the AlertRule resource.
 */
export const api_v1alert_rules_id_patch: ApiOperation<
  ApiV1alertRulesIdPatchPath,
  undefined,
  ApiV1alertRulesIdPatchBody,
  ApiV1alertRulesIdPatchResponse,
  undefined
> = {
  operationId: "api_v1alert-rules_id_patch",
  method: "PATCH",
  path: "/api/v1/alert-rules/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1alertRulesPostBody = AlertRuleAlertRuleInput
export type ApiV1alertRulesPostResponse = AlertRuleJsonld

/**
 * Creates a AlertRule resource.
 *
 * Creates a AlertRule resource.
 */
export const api_v1alert_rules_post: ApiOperation<
  undefined,
  undefined,
  ApiV1alertRulesPostBody,
  ApiV1alertRulesPostResponse,
  undefined
> = {
  operationId: "api_v1alert-rules_post",
  method: "POST",
  path: "/api/v1/alert-rules",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdcapabilitiesGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdcapabilitiesGetCollectionQuery {
  /** declared (default) | registry. */
  include?: string
}
export type ApiV1assetsAssetIdcapabilitiesGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: CapabilityJsonld[]
}

/**
 * Retrieves the collection of Capability resources.
 *
 * Retrieves the collection of Capability resources.
 */
export const api_v1assets_assetIdcapabilities_get_collection: ApiOperation<
  ApiV1assetsAssetIdcapabilitiesGetCollectionPath,
  ApiV1assetsAssetIdcapabilitiesGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdcapabilitiesGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdcapabilities_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/capabilities",
  pathParams: ["assetId"],
  queryParams: ["include"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdcapabilitiesIdGetPath {
  /** AssetResource identifier */
  assetId: string
  /** Capability identifier */
  id: string
}
export type ApiV1assetsAssetIdcapabilitiesIdGetResponse = CapabilityJsonld

/**
 * Retrieves a Capability resource.
 *
 * Retrieves a Capability resource.
 */
export const api_v1assets_assetIdcapabilities_id_get: ApiOperation<
  ApiV1assetsAssetIdcapabilitiesIdGetPath,
  undefined,
  undefined,
  ApiV1assetsAssetIdcapabilitiesIdGetResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdcapabilities_id_get",
  method: "GET",
  path: "/api/v1/assets/{assetId}/capabilities/{id}",
  pathParams: ["assetId", "id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdeventStatisticsGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdeventStatisticsGetCollectionQuery {
  /** EventStatistic category */
  category?: string
  /** EventStatistic bucket */
  bucket?: string
  /** EventStatistic group_by */
  group_by?: string
  /** EventStatistic from */
  from?: string
  /** EventStatistic to */
  to?: string
}
export type ApiV1assetsAssetIdeventStatisticsGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: EventStatisticJsonld[]
}

/**
 * Retrieves the collection of EventStatistic resources.
 *
 * Retrieves the collection of EventStatistic resources.
 */
export const api_v1assets_assetIdevent_statistics_get_collection: ApiOperation<
  ApiV1assetsAssetIdeventStatisticsGetCollectionPath,
  ApiV1assetsAssetIdeventStatisticsGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdeventStatisticsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdevent-statistics_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/event-statistics",
  pathParams: ["assetId"],
  queryParams: ["category", "bucket", "group_by", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdeventsGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdeventsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** Event category */
  category?: string
  /** Event action */
  action?: string
  /** Event severity_min */
  severity_min?: string
  /** Event from */
  from?: string
  /** Event to */
  to?: string
}
export type ApiV1assetsAssetIdeventsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: EventJsonld[]
}

/**
 * Retrieves the collection of Event resources.
 *
 * Retrieves the collection of Event resources.
 */
export const api_v1assets_assetIdevents_get_collection: ApiOperation<
  ApiV1assetsAssetIdeventsGetCollectionPath,
  ApiV1assetsAssetIdeventsGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdeventsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdevents_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/events",
  pathParams: ["assetId"],
  queryParams: ["page", "itemsPerPage", "category", "action", "severity_min", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdextensionsGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdextensionsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** The agent's own type value, matched exactly. Repeatable or comma-separated. */
  type?: string
  /** Free-text search over name and slug. */
  q?: string
  /** Extension enabled */
  enabled?: boolean
  /** true (assessed and vulnerable) | false (assessed and clean) | unknown (never assessed). The third value selects what nobody has looked at, which is the set that matters. */
  vulnerable?: string
  /** true selects extensions with a known newer version. Extensions whose update state cannot be determined are in neither set. */
  update_available?: boolean
  /** Only updates the agent marked severity=security. */
  security_update?: boolean
}
export type ApiV1assetsAssetIdextensionsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: ExtensionJsonld[]
}

/**
 * Retrieves the collection of Extension resources.
 *
 * Retrieves the collection of Extension resources.
 */
export const api_v1assets_assetIdextensions_get_collection: ApiOperation<
  ApiV1assetsAssetIdextensionsGetCollectionPath,
  ApiV1assetsAssetIdextensionsGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdextensionsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdextensions_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/extensions",
  pathParams: ["assetId"],
  queryParams: ["page", "itemsPerPage", "type", "q", "enabled", "vulnerable", "update_available", "security_update"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdmanifestGetPath {
  /** AssetResource identifier */
  assetId: string
}
export type ApiV1assetsAssetIdmanifestGetResponse = ManifestJsonld

/**
 * Retrieves a Manifest resource.
 *
 * Retrieves a Manifest resource.
 */
export const api_v1assets_assetIdmanifest_get: ApiOperation<
  ApiV1assetsAssetIdmanifestGetPath,
  undefined,
  undefined,
  ApiV1assetsAssetIdmanifestGetResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdmanifest_get",
  method: "GET",
  path: "/api/v1/assets/{assetId}/manifest",
  pathParams: ["assetId"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdmetricsGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdmetricsGetCollectionQuery {
  /** MetricSeries metric */
  metric: string
  /** MetricSeries interval */
  interval?: string
  /** MetricSeries aggregate */
  aggregate?: string
  /** MetricSeries from */
  from?: string
  /** MetricSeries to */
  to?: string
}
export type ApiV1assetsAssetIdmetricsGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: MetricSeriesJsonld[]
}

/**
 * Retrieves the collection of MetricSeries resources.
 *
 * Retrieves the collection of MetricSeries resources.
 */
export const api_v1assets_assetIdmetrics_get_collection: ApiOperation<
  ApiV1assetsAssetIdmetricsGetCollectionPath,
  ApiV1assetsAssetIdmetricsGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdmetricsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdmetrics_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/metrics",
  pathParams: ["assetId"],
  queryParams: ["metric", "interval", "aggregate", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIdoperationsGetCollectionPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIdoperationsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** Operation capability */
  capability?: string
  /** queued | running | done | error | blocked | in_flight. */
  state?: string
  /** Operation from */
  from?: string
  /** Operation to */
  to?: string
}
export type ApiV1assetsAssetIdoperationsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: OperationJsonld[]
}

/**
 * Retrieves the collection of Operation resources.
 *
 * Retrieves the collection of Operation resources.
 */
export const api_v1assets_assetIdoperations_get_collection: ApiOperation<
  ApiV1assetsAssetIdoperationsGetCollectionPath,
  ApiV1assetsAssetIdoperationsGetCollectionQuery,
  undefined,
  ApiV1assetsAssetIdoperationsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdoperations_get_collection",
  method: "GET",
  path: "/api/v1/assets/{assetId}/operations",
  pathParams: ["assetId"],
  queryParams: ["page", "itemsPerPage", "capability", "state", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1assetsAssetIdoperationsPostBody = OperationOperationRequest
export interface ApiV1assetsAssetIdoperationsPostPath {
  /** AssetResource identifier */
  assetId: string
}
export type ApiV1assetsAssetIdoperationsPostResponse = OperationJsonld

/**
 * Creates a Operation resource.
 *
 * Creates a Operation resource.
 */
export const api_v1assets_assetIdoperations_post: ApiOperation<
  ApiV1assetsAssetIdoperationsPostPath,
  undefined,
  ApiV1assetsAssetIdoperationsPostBody,
  ApiV1assetsAssetIdoperationsPostResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIdoperations_post",
  method: "POST",
  path: "/api/v1/assets/{assetId}/operations",
  pathParams: ["assetId"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 202,
  emptyResponse: false,
}

export interface ApiV1assetsAssetIduptimeGetPath {
  /** AssetResource identifier */
  assetId: string
}
export interface ApiV1assetsAssetIduptimeGetQuery {
  /** UptimeSummary from */
  from?: string
  /** UptimeSummary to */
  to?: string
}
export type ApiV1assetsAssetIduptimeGetResponse = UptimeSummaryJsonld

/**
 * Retrieves a UptimeSummary resource.
 *
 * Retrieves a UptimeSummary resource.
 */
export const api_v1assets_assetIduptime_get: ApiOperation<
  ApiV1assetsAssetIduptimeGetPath,
  ApiV1assetsAssetIduptimeGetQuery,
  undefined,
  ApiV1assetsAssetIduptimeGetResponse,
  undefined
> = {
  operationId: "api_v1assets_assetIduptime_get",
  method: "GET",
  path: "/api/v1/assets/{assetId}/uptime",
  pathParams: ["assetId"],
  queryParams: ["from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** server | site | domain | endpoint. Repeatable or comma-separated. */
  kind?: string
  /** Group UUID, or the literal "none" for assets in no group. */
  group?: string
  /** unknown | ok | warning | critical. */
  health?: string
  /** up | suspect | down | recovering. Absent means never conclusively probed. */
  availability?: string
  /** Tag name. Repeatable. */
  tag?: string
  /** Only assets whose manifest declares this capability, e.g. "core.update". Works for capabilities added after this API was written. */
  capability?: string
  /** Sites hosted on this server. */
  parent?: string
  /** Free-text search over label, URL, hostname and domain name. */
  q?: string
  /** exclude (default) | include | only. */
  archived?: string
  /** label | health | created_at | last_seen_at. */
  sort?: string
  /** Asset order */
  order?: string
}
export type ApiV1assetsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: AssetJsonld[]
}

/**
 * Retrieves the collection of Asset resources.
 *
 * Retrieves the collection of Asset resources.
 */
export const api_v1assets_get_collection: ApiOperation<
  undefined,
  ApiV1assetsGetCollectionQuery,
  undefined,
  ApiV1assetsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1assets_get_collection",
  method: "GET",
  path: "/api/v1/assets",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "kind", "group", "health", "availability", "tag", "capability", "parent", "q", "archived", "sort", "order"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsIdDeletePath {
  /** Asset identifier */
  id: string
}
export type ApiV1assetsIdDeleteResponse = void

/**
 * Removes the Asset resource.
 *
 * Removes the Asset resource.
 */
export const api_v1assets_id_delete: ApiOperation<
  ApiV1assetsIdDeletePath,
  undefined,
  undefined,
  ApiV1assetsIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1assets_id_delete",
  method: "DELETE",
  path: "/api/v1/assets/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: true,
}

export interface ApiV1assetsIdGetPath {
  /** Asset identifier */
  id: string
}
export type ApiV1assetsIdGetResponse = AssetJsonld

/**
 * Retrieves a Asset resource.
 *
 * Retrieves a Asset resource.
 */
export const api_v1assets_id_get: ApiOperation<
  ApiV1assetsIdGetPath,
  undefined,
  undefined,
  ApiV1assetsIdGetResponse,
  undefined
> = {
  operationId: "api_v1assets_id_get",
  method: "GET",
  path: "/api/v1/assets/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1assetsIdPatchBody = AssetAssetPatchJsonMergePatch
export interface ApiV1assetsIdPatchPath {
  /** Asset identifier */
  id: string
}
export type ApiV1assetsIdPatchResponse = AssetJsonld

/**
 * Updates the Asset resource.
 *
 * Updates the Asset resource.
 */
export const api_v1assets_id_patch: ApiOperation<
  ApiV1assetsIdPatchPath,
  undefined,
  ApiV1assetsIdPatchBody,
  ApiV1assetsIdPatchResponse,
  undefined
> = {
  operationId: "api_v1assets_id_patch",
  method: "PATCH",
  path: "/api/v1/assets/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1assetsIdrestorePostPath {
  /** Asset identifier */
  id: string
}
export type ApiV1assetsIdrestorePostResponse = AssetJsonld

/**
 * Creates a Asset resource.
 *
 * Creates a Asset resource.
 */
export const api_v1assets_idrestore_post: ApiOperation<
  ApiV1assetsIdrestorePostPath,
  undefined,
  undefined,
  ApiV1assetsIdrestorePostResponse,
  undefined
> = {
  operationId: "api_v1assets_idrestore_post",
  method: "POST",
  path: "/api/v1/assets/{id}/restore",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1assetsPostBody = AssetAssetInput
export type ApiV1assetsPostResponse = AssetJsonld

/**
 * Creates a Asset resource.
 *
 * Creates a Asset resource.
 */
export const api_v1assets_post: ApiOperation<
  undefined,
  undefined,
  ApiV1assetsPostBody,
  ApiV1assetsPostResponse,
  undefined
> = {
  operationId: "api_v1assets_post",
  method: "POST",
  path: "/api/v1/assets",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export type ApiV1authmeGetResponse = SessionJsonld

/**
 * Retrieves a Session resource.
 *
 * Retrieves a Session resource.
 */
export const api_v1authme_get: ApiOperation<
  undefined,
  undefined,
  undefined,
  ApiV1authmeGetResponse,
  undefined
> = {
  operationId: "api_v1authme_get",
  method: "GET",
  path: "/api/v1/auth/me",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1authmfachallengePostResponse = MfaChallengeJsonld

/**
 * Creates a MfaChallenge resource.
 *
 * Creates a MfaChallenge resource.
 */
export const api_v1authmfachallenge_post: ApiOperation<
  undefined,
  undefined,
  undefined,
  ApiV1authmfachallengePostResponse,
  undefined
> = {
  operationId: "api_v1authmfachallenge_post",
  method: "POST",
  path: "/api/v1/auth/mfa/challenge",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1authmfaverifyPostBody = MfaChallengeMfaVerification
export type ApiV1authmfaverifyPostResponse = MfaChallengeJsonld

/**
 * Creates a MfaChallenge resource.
 *
 * Creates a MfaChallenge resource.
 */
export const api_v1authmfaverify_post: ApiOperation<
  undefined,
  undefined,
  ApiV1authmfaverifyPostBody,
  ApiV1authmfaverifyPostResponse,
  undefined
> = {
  operationId: "api_v1authmfaverify_post",
  method: "POST",
  path: "/api/v1/auth/mfa/verify",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1authreauthenticatePostBody = ReauthenticationReauthenticationRequest
export type ApiV1authreauthenticatePostResponse = ReauthenticationJsonld

/**
 * Creates a Reauthentication resource.
 *
 * Creates a Reauthentication resource.
 */
export const api_v1authreauthenticate_post: ApiOperation<
  undefined,
  undefined,
  ApiV1authreauthenticatePostBody,
  ApiV1authreauthenticatePostResponse,
  undefined
> = {
  operationId: "api_v1authreauthenticate_post",
  method: "POST",
  path: "/api/v1/auth/reauthenticate",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export type ApiV1authrefreshPostBody = SessionRefreshRequest
export type ApiV1authrefreshPostResponse = SessionJsonld

/**
 * Creates a Session resource.
 *
 * Creates a Session resource.
 */
export const api_v1authrefresh_post: ApiOperation<
  undefined,
  undefined,
  ApiV1authrefreshPostBody,
  ApiV1authrefreshPostResponse,
  undefined
> = {
  operationId: "api_v1authrefresh_post",
  method: "POST",
  path: "/api/v1/auth/refresh",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1authrevokePostBody = SessionRefreshRequest
export type ApiV1authrevokePostResponse = SessionJsonld

/**
 * Creates a Session resource.
 *
 * Creates a Session resource.
 */
export const api_v1authrevoke_post: ApiOperation<
  undefined,
  undefined,
  ApiV1authrevokePostBody,
  ApiV1authrevokePostResponse,
  undefined
> = {
  operationId: "api_v1authrevoke_post",
  method: "POST",
  path: "/api/v1/auth/revoke",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1enrollmentTokensGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
}
export type ApiV1enrollmentTokensGetCollectionResponse = HydraCollectionBaseSchema & {
  member: EnrollmentTokenJsonld[]
}

/**
 * Retrieves the collection of EnrollmentToken resources.
 *
 * Retrieves the collection of EnrollmentToken resources.
 */
export const api_v1enrollment_tokens_get_collection: ApiOperation<
  undefined,
  ApiV1enrollmentTokensGetCollectionQuery,
  undefined,
  ApiV1enrollmentTokensGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1enrollment-tokens_get_collection",
  method: "GET",
  path: "/api/v1/enrollment-tokens",
  pathParams: [],
  queryParams: ["page", "itemsPerPage"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1enrollmentTokensIdDeletePath {
  /** EnrollmentToken identifier */
  id: string
}
export type ApiV1enrollmentTokensIdDeleteResponse = void

/**
 * Removes the EnrollmentToken resource.
 *
 * Removes the EnrollmentToken resource.
 */
export const api_v1enrollment_tokens_id_delete: ApiOperation<
  ApiV1enrollmentTokensIdDeletePath,
  undefined,
  undefined,
  ApiV1enrollmentTokensIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1enrollment-tokens_id_delete",
  method: "DELETE",
  path: "/api/v1/enrollment-tokens/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: true,
}

export type ApiV1enrollmentTokensPostBody = EnrollmentTokenEnrollmentTokenInput
export type ApiV1enrollmentTokensPostResponse = EnrollmentTokenJsonld

/**
 * Creates a EnrollmentToken resource.
 *
 * Creates a EnrollmentToken resource.
 */
export const api_v1enrollment_tokens_post: ApiOperation<
  undefined,
  undefined,
  ApiV1enrollmentTokensPostBody,
  ApiV1enrollmentTokensPostResponse,
  undefined
> = {
  operationId: "api_v1enrollment-tokens_post",
  method: "POST",
  path: "/api/v1/enrollment-tokens",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export interface ApiV1eventStatisticsGetCollectionQuery {
  /** EventStatistic asset */
  asset?: string
  /** EventStatistic category */
  category?: string
  /** 1h | 6h | 12h | 1d | 7d. */
  bucket?: string
  /** none | category | action | asset. */
  group_by?: string
  /** Count only severity >= 3, the aggregate's own n_severe column. */
  severe_only?: boolean
  /** EventStatistic from */
  from?: string
  /** EventStatistic to */
  to?: string
}
export type ApiV1eventStatisticsGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: EventStatisticJsonld[]
}

/**
 * Retrieves the collection of EventStatistic resources.
 *
 * Retrieves the collection of EventStatistic resources.
 */
export const api_v1event_statistics_get_collection: ApiOperation<
  undefined,
  ApiV1eventStatisticsGetCollectionQuery,
  undefined,
  ApiV1eventStatisticsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1event-statistics_get_collection",
  method: "GET",
  path: "/api/v1/event-statistics",
  pathParams: [],
  queryParams: ["asset", "category", "bucket", "group_by", "severe_only", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1eventsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** Event asset */
  asset?: string
  /** auth | user | content | extension | form | commerce | file | security | system. */
  category?: string
  /** Exact action, e.g. "login.failure". Open vocabulary: a new binding may emit an action this core has never seen, and it is searchable immediately. */
  action?: string
  /** 0-4, or debug|info|warning|error|critical. A floor, not a set. */
  severity_min?: string
  /** Actor name or id. */
  actor?: string
  /** Event source_ip */
  source_ip?: string
  /** Event security_only */
  security_only?: boolean
  /** Event q */
  q?: string
  /** RFC 3339, or a relative offset such as -24h, -7d. */
  from?: string
  /** Event to */
  to?: string
}
export type ApiV1eventsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: EventJsonld[]
}

/**
 * Retrieves the collection of Event resources.
 *
 * Retrieves the collection of Event resources.
 */
export const api_v1events_get_collection: ApiOperation<
  undefined,
  ApiV1eventsGetCollectionQuery,
  undefined,
  ApiV1eventsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1events_get_collection",
  method: "GET",
  path: "/api/v1/events",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "asset", "category", "action", "severity_min", "actor", "source_ip", "security_only", "q", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1eventsIdGetPath {
  /** Event identifier */
  id: string
}
export type ApiV1eventsIdGetResponse = EventJsonld

/**
 * Retrieves a Event resource.
 *
 * Retrieves a Event resource.
 */
export const api_v1events_id_get: ApiOperation<
  ApiV1eventsIdGetPath,
  undefined,
  undefined,
  ApiV1eventsIdGetResponse,
  undefined
> = {
  operationId: "api_v1events_id_get",
  method: "GET",
  path: "/api/v1/events/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1extensionsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** The agent's own type value, matched exactly. Repeatable or comma-separated. */
  type?: string
  /** Free-text search over name and slug. */
  q?: string
  /** Extension enabled */
  enabled?: boolean
  /** true (assessed and vulnerable) | false (assessed and clean) | unknown (never assessed). The third value selects what nobody has looked at, which is the set that matters. */
  vulnerable?: string
  /** true selects extensions with a known newer version. Extensions whose update state cannot be determined are in neither set. */
  update_available?: boolean
  /** Only updates the agent marked severity=security. */
  security_update?: boolean
}
export type ApiV1extensionsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: ExtensionJsonld[]
}

/**
 * Retrieves the collection of Extension resources.
 *
 * Retrieves the collection of Extension resources.
 */
export const api_v1extensions_get_collection: ApiOperation<
  undefined,
  ApiV1extensionsGetCollectionQuery,
  undefined,
  ApiV1extensionsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1extensions_get_collection",
  method: "GET",
  path: "/api/v1/extensions",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "type", "q", "enabled", "vulnerable", "update_available", "security_update"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1groupsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** exclude (default) | include | only. */
  archived?: string
  /** Group q */
  q?: string
}
export type ApiV1groupsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: GroupJsonld[]
}

/**
 * Retrieves the collection of Group resources.
 *
 * Retrieves the collection of Group resources.
 */
export const api_v1groups_get_collection: ApiOperation<
  undefined,
  ApiV1groupsGetCollectionQuery,
  undefined,
  ApiV1groupsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1groups_get_collection",
  method: "GET",
  path: "/api/v1/groups",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "archived", "q"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1groupsIdDeletePath {
  /** Group identifier */
  id: string
}
export type ApiV1groupsIdDeleteResponse = void

/**
 * Removes the Group resource.
 *
 * Removes the Group resource.
 */
export const api_v1groups_id_delete: ApiOperation<
  ApiV1groupsIdDeletePath,
  undefined,
  undefined,
  ApiV1groupsIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1groups_id_delete",
  method: "DELETE",
  path: "/api/v1/groups/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: true,
}

export interface ApiV1groupsIdGetPath {
  /** Group identifier */
  id: string
}
export type ApiV1groupsIdGetResponse = GroupJsonld

/**
 * Retrieves a Group resource.
 *
 * Retrieves a Group resource.
 */
export const api_v1groups_id_get: ApiOperation<
  ApiV1groupsIdGetPath,
  undefined,
  undefined,
  ApiV1groupsIdGetResponse,
  undefined
> = {
  operationId: "api_v1groups_id_get",
  method: "GET",
  path: "/api/v1/groups/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1groupsIdPatchBody = GroupGroupInputJsonMergePatch
export interface ApiV1groupsIdPatchPath {
  /** Group identifier */
  id: string
}
export type ApiV1groupsIdPatchResponse = GroupJsonld

/**
 * Updates the Group resource.
 *
 * Updates the Group resource.
 */
export const api_v1groups_id_patch: ApiOperation<
  ApiV1groupsIdPatchPath,
  undefined,
  ApiV1groupsIdPatchBody,
  ApiV1groupsIdPatchResponse,
  undefined
> = {
  operationId: "api_v1groups_id_patch",
  method: "PATCH",
  path: "/api/v1/groups/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1groupsPostBody = GroupGroupInput
export type ApiV1groupsPostResponse = GroupJsonld

/**
 * Creates a Group resource.
 *
 * Creates a Group resource.
 */
export const api_v1groups_post: ApiOperation<
  undefined,
  undefined,
  ApiV1groupsPostBody,
  ApiV1groupsPostResponse,
  undefined
> = {
  operationId: "api_v1groups_post",
  method: "POST",
  path: "/api/v1/groups",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export interface ApiV1metricsGetCollectionQuery {
  /** Asset UUID. Repeatable. */
  asset: string
  /** Metric name, e.g. http.response_ms, cpu.pct, disk.pct, tls.days_left. Repeatable. */
  metric: string
  /** 1m | 5m | 15m | 1h | 6h | 1d. Chosen from the window when omitted. */
  interval?: string
  /** avg | min | max | sum | last. */
  aggregate?: string
  /** key:value, repeatable. e.g. tag=prober:primary to isolate one vantage point. */
  tag?: string
  /** MetricSeries from */
  from?: string
  /** MetricSeries to */
  to?: string
}
export type ApiV1metricsGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: MetricSeriesJsonld[]
}

/**
 * Retrieves the collection of MetricSeries resources.
 *
 * Retrieves the collection of MetricSeries resources.
 */
export const api_v1metrics_get_collection: ApiOperation<
  undefined,
  ApiV1metricsGetCollectionQuery,
  undefined,
  ApiV1metricsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1metrics_get_collection",
  method: "GET",
  path: "/api/v1/metrics",
  pathParams: [],
  queryParams: ["asset", "metric", "interval", "aggregate", "tag", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1notificationChannelsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
}
export type ApiV1notificationChannelsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: NotificationChannelJsonld[]
}

/**
 * Retrieves the collection of NotificationChannel resources.
 *
 * Retrieves the collection of NotificationChannel resources.
 */
export const api_v1notification_channels_get_collection: ApiOperation<
  undefined,
  ApiV1notificationChannelsGetCollectionQuery,
  undefined,
  ApiV1notificationChannelsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_get_collection",
  method: "GET",
  path: "/api/v1/notification-channels",
  pathParams: [],
  queryParams: ["page", "itemsPerPage"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1notificationChannelsIdDeletePath {
  /** NotificationChannel identifier */
  id: string
}
export type ApiV1notificationChannelsIdDeleteResponse = void

/**
 * Removes the NotificationChannel resource.
 *
 * Removes the NotificationChannel resource.
 */
export const api_v1notification_channels_id_delete: ApiOperation<
  ApiV1notificationChannelsIdDeletePath,
  undefined,
  undefined,
  ApiV1notificationChannelsIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_id_delete",
  method: "DELETE",
  path: "/api/v1/notification-channels/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 204,
  emptyResponse: true,
}

export interface ApiV1notificationChannelsIdGetPath {
  /** NotificationChannel identifier */
  id: string
}
export type ApiV1notificationChannelsIdGetResponse = NotificationChannelJsonld

/**
 * Retrieves a NotificationChannel resource.
 *
 * Retrieves a NotificationChannel resource.
 */
export const api_v1notification_channels_id_get: ApiOperation<
  ApiV1notificationChannelsIdGetPath,
  undefined,
  undefined,
  ApiV1notificationChannelsIdGetResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_id_get",
  method: "GET",
  path: "/api/v1/notification-channels/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1notificationChannelsIdPatchBody = NotificationChannelNotificationChannelInputJsonMergePatch
export interface ApiV1notificationChannelsIdPatchPath {
  /** NotificationChannel identifier */
  id: string
}
export type ApiV1notificationChannelsIdPatchResponse = NotificationChannelJsonld

/**
 * Updates the NotificationChannel resource.
 *
 * Updates the NotificationChannel resource.
 */
export const api_v1notification_channels_id_patch: ApiOperation<
  ApiV1notificationChannelsIdPatchPath,
  undefined,
  ApiV1notificationChannelsIdPatchBody,
  ApiV1notificationChannelsIdPatchResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_id_patch",
  method: "PATCH",
  path: "/api/v1/notification-channels/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1notificationChannelsIdtestPostPath {
  /** NotificationChannel identifier */
  id: string
}
export type ApiV1notificationChannelsIdtestPostResponse = NotificationChannelJsonld

/**
 * Creates a NotificationChannel resource.
 *
 * Creates a NotificationChannel resource.
 */
export const api_v1notification_channels_idtest_post: ApiOperation<
  ApiV1notificationChannelsIdtestPostPath,
  undefined,
  undefined,
  ApiV1notificationChannelsIdtestPostResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_idtest_post",
  method: "POST",
  path: "/api/v1/notification-channels/{id}/test",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1notificationChannelsPostBody = NotificationChannelNotificationChannelInput
export type ApiV1notificationChannelsPostResponse = NotificationChannelJsonld

/**
 * Creates a NotificationChannel resource.
 *
 * Creates a NotificationChannel resource.
 */
export const api_v1notification_channels_post: ApiOperation<
  undefined,
  undefined,
  ApiV1notificationChannelsPostBody,
  ApiV1notificationChannelsPostResponse,
  undefined
> = {
  operationId: "api_v1notification-channels_post",
  method: "POST",
  path: "/api/v1/notification-channels",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export interface ApiV1operationsGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** Operation asset */
  asset?: string
  /** Operation capability */
  capability?: string
  /** Operation state */
  state?: string
  /** Operation requested_by */
  requested_by?: string
  /** Operation from */
  from?: string
  /** Operation to */
  to?: string
}
export type ApiV1operationsGetCollectionResponse = HydraCollectionBaseSchema & {
  member: OperationJsonld[]
}

/**
 * Retrieves the collection of Operation resources.
 *
 * Retrieves the collection of Operation resources.
 */
export const api_v1operations_get_collection: ApiOperation<
  undefined,
  ApiV1operationsGetCollectionQuery,
  undefined,
  ApiV1operationsGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1operations_get_collection",
  method: "GET",
  path: "/api/v1/operations",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "asset", "capability", "state", "requested_by", "from", "to"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1operationsIdGetPath {
  /** Operation identifier */
  id: string
}
export type ApiV1operationsIdGetResponse = OperationJsonld

/**
 * Retrieves a Operation resource.
 *
 * Retrieves a Operation resource.
 */
export const api_v1operations_id_get: ApiOperation<
  ApiV1operationsIdGetPath,
  undefined,
  undefined,
  ApiV1operationsIdGetResponse,
  undefined
> = {
  operationId: "api_v1operations_id_get",
  method: "GET",
  path: "/api/v1/operations/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1operationsIdretryPostPath {
  /** Operation identifier */
  id: string
}
export type ApiV1operationsIdretryPostResponse = OperationJsonld

/**
 * Creates a Operation resource.
 *
 * Creates a Operation resource.
 */
export const api_v1operations_idretry_post: ApiOperation<
  ApiV1operationsIdretryPostPath,
  undefined,
  undefined,
  ApiV1operationsIdretryPostResponse,
  undefined
> = {
  operationId: "api_v1operations_idretry_post",
  method: "POST",
  path: "/api/v1/operations/{id}/retry",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 202,
  emptyResponse: false,
}

export type ApiV1rolesGetCollectionResponse = HydraCollectionBaseSchemaNoPagination & {
  member: RoleJsonld[]
}

/**
 * Retrieves the collection of Role resources.
 *
 * Retrieves the collection of Role resources.
 */
export const api_v1roles_get_collection: ApiOperation<
  undefined,
  undefined,
  undefined,
  ApiV1rolesGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1roles_get_collection",
  method: "GET",
  path: "/api/v1/roles",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1usersGetCollectionQuery {
  /** The collection page number */
  page?: number
  /** The number of items per page */
  itemsPerPage?: number
  /** User role */
  role?: string
  /** User active */
  active?: boolean
  /** User q */
  q?: string
}
export type ApiV1usersGetCollectionResponse = HydraCollectionBaseSchema & {
  member: UserJsonld[]
}

/**
 * Retrieves the collection of User resources.
 *
 * Retrieves the collection of User resources.
 */
export const api_v1users_get_collection: ApiOperation<
  undefined,
  ApiV1usersGetCollectionQuery,
  undefined,
  ApiV1usersGetCollectionResponse,
  undefined
> = {
  operationId: "api_v1users_get_collection",
  method: "GET",
  path: "/api/v1/users",
  pathParams: [],
  queryParams: ["page", "itemsPerPage", "role", "active", "q"],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export interface ApiV1usersIdDeletePath {
  /** User identifier */
  id: string
}
export type ApiV1usersIdDeleteResponse = void

/**
 * Removes the User resource.
 *
 * Removes the User resource.
 */
export const api_v1users_id_delete: ApiOperation<
  ApiV1usersIdDeletePath,
  undefined,
  undefined,
  ApiV1usersIdDeleteResponse,
  undefined
> = {
  operationId: "api_v1users_id_delete",
  method: "DELETE",
  path: "/api/v1/users/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: true,
}

export interface ApiV1usersIdGetPath {
  /** User identifier */
  id: string
}
export type ApiV1usersIdGetResponse = UserJsonld

/**
 * Retrieves a User resource.
 *
 * Retrieves a User resource.
 */
export const api_v1users_id_get: ApiOperation<
  ApiV1usersIdGetPath,
  undefined,
  undefined,
  ApiV1usersIdGetResponse,
  undefined
> = {
  operationId: "api_v1users_id_get",
  method: "GET",
  path: "/api/v1/users/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: false,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1usersIdPatchBody = UserUserInputJsonMergePatch
export interface ApiV1usersIdPatchPath {
  /** User identifier */
  id: string
}
export type ApiV1usersIdPatchResponse = UserJsonld

/**
 * Updates the User resource.
 *
 * Updates the User resource.
 */
export const api_v1users_id_patch: ApiOperation<
  ApiV1usersIdPatchPath,
  undefined,
  ApiV1usersIdPatchBody,
  ApiV1usersIdPatchResponse,
  undefined
> = {
  operationId: "api_v1users_id_patch",
  method: "PATCH",
  path: "/api/v1/users/{id}",
  pathParams: ["id"],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

export type ApiV1usersPostBody = UserUserInput
export type ApiV1usersPostResponse = UserJsonld

/**
 * Creates a User resource.
 *
 * Creates a User resource.
 */
export const api_v1users_post: ApiOperation<
  undefined,
  undefined,
  ApiV1usersPostBody,
  ApiV1usersPostResponse,
  undefined
> = {
  operationId: "api_v1users_post",
  method: "POST",
  path: "/api/v1/users",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 201,
  emptyResponse: false,
}

export type LoginCheckPostBody = {
  email: string
  password: string
}
export type LoginCheckPostResponse = {
  token: string
}

/**
 * Creates a user token.
 *
 * Creates a user token.
 */
export const login_check_post: ApiOperation<
  undefined,
  undefined,
  LoginCheckPostBody,
  LoginCheckPostResponse,
  undefined
> = {
  operationId: "login_check_post",
  method: "POST",
  path: "/api/v1/auth/token",
  pathParams: [],
  queryParams: [],
  headerParams: [],
  hasBody: true,
  secured: true,
  successStatus: 200,
  emptyResponse: false,
}

